import { useState, useEffect, useMemo } from 'react'
import { isAndroid } from '@docs/common'
import Helmet from 'react-helmet'
import { hot } from 'react-hot-loader/root'

type ViewportSettingProps = {
  base: number
}

ScaledViewport.defaultProps = {
  base: 375,
}

function ScaledViewport(props: ViewportSettingProps) {
  const { base } = props
  const [scale, setScale] = useState(1)

  const content = useMemo(() => {
    return `width=${base}, initial-scale=${scale}, minimum-scale=${scale}, maximum-scale=${scale}, user-scalable=no`
  }, [base, scale])

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isiPad = /ipad/i.test(userAgent);
    const isAndroidTablet = /android|silk/i.test(userAgent) && !/mobile/i.test(userAgent);
    const isTabletDevice = isiPad || isAndroidTablet;
    function handleResize() {
      // 横屏状态
      const isLandscape = window.outerWidth > window.outerHeight
      if (isTabletDevice && isLandscape) {
        setScale(1)
      } else {
        setScale(window.outerWidth / base)
      }
    }

    handleResize()

    // 只保留一个 meta
    const oldViewport = document.head.querySelector('meta[name="viewport"]')
    if (oldViewport) {
      document.head.removeChild(oldViewport)
    }

    window.addEventListener('resize', handleResize)
    window.addEventListener('orientationchange', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('orientationchange', handleResize)
    }
  }, [base])

  return (
    <Helmet>
      <meta name="viewport" content={content} />
    </Helmet>
  )
}

export default hot(ScaledViewport)
